/**
 * @generated SignedSource<<afb02234e6e0e76217a6e59a2789ff23>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type dateTime_nativeIssueTable_DateTimeCell$data = {
  readonly " $fragmentSpreads": FragmentRefs<"dateTime_nativeIssueTable_DateTimeCellInner">;
  readonly " $fragmentType": "dateTime_nativeIssueTable_DateTimeCell";
};
export type dateTime_nativeIssueTable_DateTimeCell$key = {
  readonly " $data"?: dateTime_nativeIssueTable_DateTimeCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"dateTime_nativeIssueTable_DateTimeCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistinlineeditingrelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "dateTime_nativeIssueTable_DateTimeCell",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistinlineeditingrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "isInlineEditingEnabled",
              "variableName": "isInlineEditingEnabled"
            }
          ],
          "kind": "FragmentSpread",
          "name": "dateTime_nativeIssueTable_DateTimeCellInner"
        }
      ]
    }
  ],
  "type": "JiraDateTimePickerField"
};

(node as any).hash = "79836ba88e91ff45e1aec633e339f0bc";

export default node;
